import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { getAnalyticsExtensionConnectionIcon } from '~src/settings/extensions-settings/analytics/AnalyticsExtensionConnectionIcons';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { ConnectsToCell } from '~src/spacesPlatform/components/ListView/DataConnectionComponents';
import { ActionsMenuCell } from '~src/spacesPlatform/components/ListView/dataGridCells/ActionsCells';
import { PlainTextCellWithIconAndCount } from '~src/spacesPlatform/components/ListView/dataGridCells/PlainTextAndNumberCells';
import { ListViewGridColumnGenerator, ListViewGridColumnGeneratorParams } from '~src/spacesPlatform/components/ListView/ListViewGridColumnGenerator';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';
import { CommonColumn } from '~src/spacesPlatform/components/ListView/types/Columns';
import { getKeyForExplorableItem } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { isFlowAnalyticsExtensionRow } from '../../models/FlowAnalyticsExtensionRow';

export function FlowConnectionConnectsToColumn(params: ListViewGridColumnGeneratorParams): DataGrid.Column {
  const column = new ListViewGridColumnGenerator(params).getColumn(CommonColumn.ConnectsTo);
  const extensionCell = StyledCellFormatter(React.createFactory(FlowAnalyticsExtensionConnectionCell), { paddingLeft: CommonStyles.Sizes.MediumSpace });
  return {
    ...column,
    cellFormatter: props => isFlowAnalyticsExtensionRow(props.row.data)
      ? extensionCell(props)
      : column.cellFormatter(props),
  };
}

export function FlowAnalyticsExtensionConnectionCell(props: BodyCell.Props): JSX.Element {
  const row = props.row.data;
  if (!isFlowAnalyticsExtensionRow(row)) {
    return null;
  }
  const connection = row.analyticsExtensionConnection;
  return <PlainTextCellWithIconAndCount
    {...props}
    metadataFn={() => ({
      text: connection.connectionName,
      title: connection.connectionName,
      iconUrl: imgPath(getAnalyticsExtensionConnectionIcon(connection.connectionType)),
      iconTitle: row.connectionTypeDisplayName,
      hideTooltips: true,
    })}
    testId={ConnectsToCell.ConnectsToCellTestId}
  />;
}

function FlowConnectionActionsCellContent({ selected, ...props }: BodyCell.Props & { selected: boolean }): JSX.Element {
  const formatter = React.useMemo(() => ActionsMenuCell({
    getContentItem: row => row.data as IContentInfo,
    isRowSelected: () => selected,
    isAccessDenied: row => !!row.data.isAccessDenied,
    isRowDisabled: row => row.data.id === '',
  }, { height: ExplorerStyles.LIST_VIEW_ROW_OUTER_HEIGHT }), [selected]);
  return formatter(props);
}

// Column factories run once; subscribe here so checkbox changes update the row menu.
const FlowConnectionActionsCell = connect((state: AppState, props: BodyCell.Props) => ({
  selected: !!state.contentExplorer.selection.selectedItems[getKeyForExplorableItem(props.row.data as IContentInfo)],
}))(FlowConnectionActionsCellContent);

export function FlowConnectionActionsColumn(params: ListViewGridColumnGeneratorParams): DataGrid.Column {
  const column = new ListViewGridColumnGenerator(params).getColumn(CommonColumn.ActionsMenu);
  return { ...column, cellFormatter: React.createFactory(FlowConnectionActionsCell) };
}
